import { render, staticRenderFns } from "./input-paid-now.vue?vue&type=template&id=c8850680"
import script from "./input-paid-now.vue?vue&type=script&lang=js"
export * from "./input-paid-now.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports